export default class extends Controller {
  static targets = ['parent', 'child'];

  connect() {
    setTimeout(this.setChild.bind(this), 100);
    App.DynamicSelect.onChange(this.parentTarget, this.updateChild.bind(this));
  }

  updateChild() {
    App.DynamicSelect.setValue(this.childTarget, null);
    this.setChild();
  }

  //
  // INTERNAL USE
  //

  setChild() {
    if (this.disableOnNull && !this.parentVal) {
      App.DynamicSelect.disable(this.childTarget);
    } else {
      App.DynamicSelect.enable(this.childTarget);
      if (this.childOptionsRemote) {
        App.Helpers.setDataAttribute(this.childTarget, 'select2-ajax-url', this.remoteOptionsURL);
      }
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get parentVal() {
    return App.DynamicSelect.getValue(this.parentTarget);
  }

  get disableOnNull() {
    return !['0', false, 'false'].includes(this.data.get('disable-on-null'));
  }

  get childOptionsRemote() {
    return !!this.remoteOptionsURL;
  }

  get remoteOptionsURL() {
    return this.childTarget.dataset.dependentSelectBaseUrl.replace(/PARENT_ID/g, this.parentVal);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/dependent-select-controller.js